import { connect } from 'react-redux';
import { loginAsync, loginFacebookAsync } from '../../../lib/dataLayer';
import LoginFormPage from '../components/LoginFormPage';

const mapDispatchToProps = {
  onLogin: loginAsync,
  onFacebookLogin: loginFacebookAsync,
};

export default connect(null, mapDispatchToProps)(LoginFormPage);



// WEBPACK FOOTER //
// ./src/modules/LoginFormPage/containers/LoginContainer.js